import { HttpClient } from '../utils/httpClient';

const PATH = {
    create: '/admin/onboarding',
    get: '/admin/onboarding',
    update: '/admin/onboarding',
    delete: '/admin/onboarding',
    uploadFiles: '/admin/onboarding/upload-files',

    // root routes
    getRoot: '/root/onboarding',
    updateRoot: '/root/onboarding',
    deleteRoot: '/root/onboarding',
    updateStatusRoot: '/root/onboarding/update-status',
    uploadFilesRoot: '/root/onboarding/upload-files',
};

const GetAll = (start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.get).then(callback).catch(error).finally(next);
};

const Create = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(PATH.create, payload).then(callback).catch(error).finally(next);
};

const Update = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.update}/${id}`, payload).then(callback).catch(error).finally(next);
};

const Delete = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${id}`).then(callback).catch(error).finally(next);
};

const UploadFiles = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(PATH.uploadFiles, payload).then(callback).catch(error).finally(next);
};

const RemoveUploadedFile = (onboardingId, id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.uploadFiles}/${onboardingId}/${id}`).then(callback).catch(error).finally(next);
};

const GetUploadedFileSignedURL = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.uploadFiles}/signed-url`, { params }).then(callback).catch(error).finally(next);
};

const GetAllForRoot = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.getRoot, { params }).then(callback).catch(error).finally(next);
};

const UpdateForRoot = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.updateRoot}/${id}`, payload).then(callback).catch(error).finally(next);
};

const DeleteForRoot = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.deleteRoot}/${id}`).then(callback).catch(error).finally(next);
};

const UpdateStatusForRoot = (payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.updateStatusRoot}`, payload).then(callback).catch(error).finally(next);
};

const UploadFilesForRoot = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(PATH.uploadFilesRoot, payload).then(callback).catch(error).finally(next);
};

const RemoveUploadedFileForRoot = (onboardingId, id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.uploadFilesRoot}/${onboardingId}/${id}`).then(callback).catch(error).finally(next);
};

const GetUploadedFileSignedURLForRoot = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.uploadFilesRoot}/signed-url`, { params }).then(callback).catch(error).finally(next);
};

export const OnboardingService = { GetAll, Create, Update, Delete, UploadFiles, RemoveUploadedFile, GetUploadedFileSignedURL };

export const RootOnboardingService = {
    GetAll: GetAllForRoot,
    Update: UpdateForRoot,
    Delete: DeleteForRoot,
    UpdateStatus: UpdateStatusForRoot,
    UploadFiles: UploadFilesForRoot,
    RemoveUploadedFile: RemoveUploadedFileForRoot,
    GetUploadedFileSignedURL: GetUploadedFileSignedURLForRoot,
};
